import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook_footer",
  "use": "facebook_footer-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"facebook_footer\">\r\n\t<path d=\"M13.6073 24V13.4996H17.1482L17.8219 9.15627H13.6073V6.33896C13.6073 5.1504 14.195 3.9912 16.0826 3.9912H18V0.29347C18 0.29347 16.2607 0 14.5986 0C11.126 0 8.85845 2.0807 8.85845 5.84593V9.15627H5V13.4996H8.85845V24H13.6073Z\" fill=\"#93CEFC\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol